const ENABLED_KEY = "haptics-enabled";

function safeLocal(): Storage | null {
	if (typeof window === "undefined") return null;
	try {
		return window.localStorage;
	} catch {
		return null;
	}
}

export function getHapticsEnabled(): boolean {
	const raw = safeLocal()?.getItem(ENABLED_KEY);
	if (raw === null || raw === undefined) return true;
	return raw === "1";
}

export function setHapticsEnabled(value: boolean): void {
	safeLocal()?.setItem(ENABLED_KEY, value ? "1" : "0");
	if (typeof window !== "undefined") {
		window.dispatchEvent(new CustomEvent("haptics:changed", { detail: value }));
	}
}
